export interface IPOSProductSearch {
  id: number;
  name: string;
  key: string;
}

export const posProductSearch = [
  {
    id: 1,
    name: 'Product Search',
    key: 'product'
  },
  {
    id: 2,
    name: 'Menu List',
    key: 'menu'
  }
]
